
import { defineComponent, ref } from "vue";
export default defineComponent({
  props: {
    tableData: Array,
    tableColumn: Array,
    // 是非需要滚动条
    isHeight: {
      type: Boolean,
      default: false,
    },
    // 是否需要序号
    isIndex: {
      type: Boolean,
      default: true,
    },
    // 是否需要分页
    isPagination: {
      type: Boolean,
      default: true,
    },
    // 当前页面
    currentPage: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    // 自定义每页面数量组
    pageSizes: {
      type: Array,
      default: () => [5, 10, 20, 50],
    },
    // 每页面数量
    pageSize: {
      type: Number,
      default: 10,
    },
    // 是否需要多选
    ifselection: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    /*
     * 分页
     * */
    const handleSizeChange = (num: number) => {
      emit("handleSizeChange", num);
    };
    const getRowKey = (item: any) => {
      emit("getRowKey", item);
    };
    const handleCurrentChange = (page: number) => {
      emit("handleCurrentChange", page);
    };
    // 选中改变事件
    const handleSelectionChange = (val: void) => {
      emit("handleSelectionChange", val);
    };
    // 单个选中事件
    const handleSelect = (list: void) => {
      emit("handleSelect", list);
    };
    // 全选事件
    const handleSelectAll = (val: void) => {
      emit("handleSelectAll", val);
    };
    return {
      handleSizeChange,
      handleCurrentChange,
      handleSelectionChange,
      handleSelect,
      handleSelectAll,
      getRowKey,
    };
  },
});
